export default __webpack_public_path__ + "static/product_item_001-d54c4897110dccbf25b84be1515cd8b1.jpg";